import { makeRequest } from "./api";

export const FetchCacelations = async () => {
  return makeRequest("/api/admin/cancellationPolicy/fetch");
};

export const CreateCacelation = async (itemName, itemContent, status) => {
  return makeRequest("/api/admin/cancellationPolicy/create", {
    method: "POST",
    data: {
      itemName,
      itemContent,
      status,
    },
  });
};

export const UpdateCacelation = async (
  cancellationPolicyId,
  itemName,
  itemContent,
  status,
) => {
  return makeRequest("/api/admin/cancellationPolicy/update", {
    method: "PUT",
    data: {
      cancellationPolicyId,
      itemName,
      itemContent,
      status,
    },
  });
};

export const DeleteCacelation = async (cancellationPolicyId) => {
  return makeRequest(
    `/api/admin/cancellationPolicy/remove/${cancellationPolicyId}`,
    {
      method: "DELETE",
    },
  );
};
